/**
 * Booking cvonsist of steps.
 * 
 * Step 1: 
 *   Save patient data along Patient profile. Wait it until it gets synced. 
 * Step 2: 
 *   Create ServiceRequest based on the draft. In UK äpp there will be only 1 service so
 *   we can select this automatically. 
 * Step3: 
 *   Wait serviceRequest comfimation
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Trans } from "react-i18next";
import TopNav from  '../PatientApp/TopNav';
import Modal from  '../Modal/Modal';
import Button from './../Buttons/Button';
import BookingStartForm from "./../BookingStartForm/BookingStartForm";
import TimePicker from "./TimePicker";
import RedirectBooking from "./RedirectBooking";

import StateMachine from 'react-simple-state/dist';
import i18n from "../../Documental/Localization/i18n";
const appState = new StateMachine();


function BookingPage() {
  const navigate = useNavigate();
  
  const handleBackButton = ( lang  ) => {
    navigate(-1);
    return false;
  } 
  
  const [ bookingStep, setBookingStep ] = useState( 1 );
  const [ acknowledgeExtraInfoShown, setAcknowledgeExtraInfoShown ] = useState( 0 );
  const [ acknowledgeExtraInfoAcknowledged, setAcknowledgeExtraInfoAcknowledged ] = useState( 0 );

  // if app operates in "repeat visit" mode, skip step 1 and go straight to step 2
  if( bookingStep === 1 ){
    let currentAppMode = appState.getState( 'app-main-mode' );
    if( currentAppMode.appMainMode === "app-main-mode-repeat-visit" ){
      setBookingStep( 2 );
    }
  }
  
  useEffect(() => {
    return function cleanup() {};
  });
  
  
  const handleAcknowledgeExtraInfo = ( ) => {
    if( acknowledgeExtraInfoAcknowledged === 0 ){
      return;
    }
    setAcknowledgeExtraInfoShown( 1 );
  }

  const handleAcknowledgedConfirmClick = ( ) => {
    if( acknowledgeExtraInfoAcknowledged === 0 ){
      setAcknowledgeExtraInfoAcknowledged( 1 );
    } else {
      setAcknowledgeExtraInfoAcknowledged( 0 );
    }
  }

  const handleSubmitDone = ( patientResourceId, formData ) => {
    
    window.mainResult.patientWentToFillBookingForm = true;

    let currentAppMode2 = appState.getState( 'app-main-mode' );
    if( currentAppMode2.appMainMode === "app-main-mode-free-assessment" ){
      setBookingStep( 3 );
      return;
    }
    
    setBookingStep( 2 );
  }

  const handleBookingDone = ( ) => {
    
    window.mainResult.patientWentToFillBookingForm = true;
    
    navigate( './../rate' );
    //setBookingStep( 5 );
  }

  const handleSkipBooking = ( ) => {
    navigate( './../rate' );
  }
  
  let pagesClass = "app-page booking";
  let buttonProceedClasses = "btn next mb-6";
  if( bookingStep === 1 ){
    buttonProceedClasses = "btn loading-full mb-6";
    pagesClass = "app-page booking";
  }

  if( bookingStep === 2 ){
    pagesClass = "app-page booking pick-time";
  }

  if( bookingStep === 3 ){
    pagesClass = "app-page booking with-redirection";
  }

  if( bookingStep === 5 ){
    pagesClass = "app-page booking booking-finished";
  }
  
  //if .acknowledgeExtraInfoStep is set, show it before booking
  let showAcknowledgeExtraInfo = false;
  if( 
    typeof window.mainResult !== 'undefined' && 
    typeof window.mainResult.acknowledgeExtraInfoStep !== 'undefined' && 
    window.mainResult.acknowledgeExtraInfoStep.show === true 
  ){
    showAcknowledgeExtraInfo = true;
  }
  

  let formTitle = "Book a video-consultation";
  if( typeof window.mainResult !== 'undefined' && typeof window.mainResult.finalServiceProvider !== 'undefined' ){
    if( window.mainResult.finalServiceProvider === "psychiatrist" ){
      formTitle = "Book a video-consultation with a psychiatrist";
    }
    if( window.mainResult.finalServiceProvider === "psychologist" ){
      formTitle = "Book a video-consultation with a psychologist";
    }
  }

  // temporary overwrite
  let currentAppMode = appState.getState( 'app-main-mode' );
  if( currentAppMode.appMainMode === "app-main-mode-free-assessment" ){
    formTitle = "We recommend a psychiatric consultation.";
  }

  //
  if( currentAppMode.appMainMode === "app-main-mode-repeat-visit" ){
    formTitle = "Book a repeat visit";
  }
  

  // TODO - instead of eraly return- implement as actual step like the rest in here
  // and extract to separate component
  if( showAcknowledgeExtraInfo && acknowledgeExtraInfoShown === 0 ){
    let acknowledgeConfirmText = i18n.t('Continue');
    let acknowledgeHeading = i18n.t('Please note!');
    let checkboxLabel = i18n.t('I have read and agree to the terms and conditions of the service');
    if( i18n.language === 'en' ){
      acknowledgeConfirmText = i18n.t('Next'); // This is intended, english has different wording by client request
    }

    let btnClasses = "btn full-width next mb-6";
    if( acknowledgeExtraInfoAcknowledged === 0 ){
      btnClasses = "btn dark next center disabled full-width mb-6";
    }

    let akChecked = acknowledgeExtraInfoAcknowledged === 1 ? true : false;

    return (
      <div>

        <div className="app-page booking acknowledge-extra-info">
          <div>
            <div className="mb-7 back-wrap">
              <span className="icon-back-white" onClick={ function(){ handleBackButton(); } } ></span>
            </div>
          </div>

          <div className="">
            <h1 className="mb-8">{acknowledgeHeading}</h1>
            <p className=" text-white acknowledge-text">
              {window.mainResult.acknowledgeExtraInfoStep.text}
            </p>
            
          </div>

          <div className="app-fragment pull-bottom-fixed">
            <div className="acknowledge-checkbox-wrap text-white mb-8">
              <div className="">
                <input type="checkbox" className="dm-toggle" 
                  id="acknowledge-1"
                  checked={akChecked} 
                  onChange={() => { handleAcknowledgedConfirmClick(); } } />
              </div>
              <div className="label">
                <label htmlFor="acknowledge-1">{checkboxLabel}</label>
              </div>
            </div>

            <span className={btnClasses} 
              onClick={() => { handleAcknowledgeExtraInfo(); } }
            >
              {acknowledgeConfirmText}
            </span>
          </div>

          <div className="invisible on-for-taking-up-space-same-amount-as-real-button-above">
            <Button className="dark mb-6">
              {acknowledgeConfirmText}
            </Button>
          </div>

        </div>
      </div>
    );
  }

  // Default - show steps
  return (
    <div>

      <div className={pagesClass}>
        
        {( bookingStep < 4 ) && (
          <div>
            <div className="mb-7 back-wrap">
              <span className="icon-back-white" onClick={ function(){ handleBackButton(); } } ></span>
            </div>
            <h1 className="mb-8"><Trans>{formTitle}</Trans></h1>
          </div>
        )}

        {( bookingStep === 1 ) && (
          <BookingStartForm onSubmitDone={handleSubmitDone} />
        )}

        {( bookingStep === 2 ) && (
          <TimePicker clientName="" clientPseudoIdentification="" onBookingDone={handleBookingDone} onSkipBooking={handleSkipBooking} />
        )}

        {( bookingStep === 3 ) && (
          <RedirectBooking  />
        )}

        {( bookingStep === 5 ) && (
          <div className="">
            <h1 className="mb-8"><Trans>Thank you</Trans></h1>
          </div>
        )}

      </div>
    </div>
  );
}

export default BookingPage;